<template>
	<div 
	v-loading.fullscreen="uploadloading"
	:element-loading-text="$t('tipsInfo.loadingText')"
	element-loading-spinner="el-icon-loading"
	element-loading-background="rgba(0, 0, 0, 0.8)"
	>
		<!-- 库存列表 -->
		<div class="listHeader">
			<i></i><span>{{$t('ksaWhInventoryPage.tabTwoPageTitle')}}</span>
		</div>
		<el-form :model="queryParams" ref="queryForm" :inline="true" label-width="auto"
		  style="margin:10px 0 0 15px">
		  <el-form-item label prop="companyProductCode">
		    <el-input type="textarea" v-model="companyProductCode" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.clientProductCode')" clearable />
		  </el-form-item>
			<el-form-item label prop="productCode">
			  <el-input v-model="queryParams.productCode" :placeholder="$t('tipsInfo.inputPlaceholder') + $t('commonInfo.productCode')" clearable />
			</el-form-item>
		  <el-form-item>
		    <el-button type="primary" icon="el-icon-search" @click="handleQuery">{{$t('commonInfo.searchBtn')}}</el-button>
				<el-button type="primary" icon="el-icon-refresh" @click="getList">{{$t('commonInfo.refreshBtn')}}</el-button>
				<el-button icon="el-icon-refresh" @click="handleReset">{{$t('commonInfo.dialogBtnReset')}}</el-button>
		  </el-form-item>
			<el-form-item>
				<el-button icon="el-icon-download" type="primary" @click="handleExportProduct()">{{$t('ksaWhInventoryPage.exportAllSkuData')}}</el-button>
			</el-form-item>
		</el-form>
		<el-card class="skuStatistics">
			<div class="statOpt">
				<label>{{$t('ksaWhInventoryPage.totalSku') + ":"}}</label>
				<animate-number ref="skuStatisticsOne" from="0" :key="skuStatistics.totalSku" :to="skuStatistics.totalSku" easing="easeOutQuad"
					mode="manual" :decimals="2" duration="1000"></animate-number>
			</div>
			<div class="statOpt">
				<label>{{$t('ksaWhInventoryPage.totalPcs') + ":"}}</label>
				<animate-number ref="skuStatisticsTwo" from="0" :key="skuStatistics.totalPcs" :to="skuStatistics.totalPcs" easing="easeOutQuad"
					mode="manual" :decimals="2" duration="1000"></animate-number>
			</div>
			<div class="statOpt">
				<label>{{$t('ksaWhInventoryPage.totalSkuVolume') + "(CBM):"}}</label>
				<span>{{skuStatistics.totalVolume}}</span>
			</div>
		</el-card>
		
		<!-- 展示 -->
		<el-table style="margin:0 15px;width: calc(100% - 30px);font-size: 16px;" v-loading="loading" :data="dataList" border>
		  <el-table-column :label="$t('commonInfo.productCode')" align="center" prop="productCode"/>
		  <el-table-column :label="$t('commonInfo.clientProductCode')" align="center" prop="clientProductCode" />
		  <el-table-column :label="$t('commonInfo.productName')" align="center" prop="productNm" />
		  <el-table-column prop="img " :label="$t('commonInfo.photo')" align="center" width="80" >
				<template slot-scope="{ row }">
						<img v-if="row.img != '' && row.img.length != 0" :src="row.img" @click="handleViewImg(row.img)" style="width: 60px;height: 60px;"/>
				</template>
		  </el-table-column>
			<el-table-column :label="$t('commonInfo.productQuantity')" align="center" prop="inStockQty" />
			<el-table-column label="可用数量" align="center" prop="usableQty" />
			<el-table-column :label="$t('commonInfo.appointmentQuantity')" align="center" prop="orderedQty" />
			<el-table-column label="占用数量" align="center" prop="occupiedQty" />
			
		</el-table>
		<div class="pageBottom">
		  <el-pagination
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    :current-page="queryParams.page"
		    :page-sizes="[10, 20, 30, 40]"
		    :page-size="queryParams.limit"
		    layout="total, sizes, prev, pager, next, jumper"
		    :total="total"
		  ></el-pagination>
		</div>
		<el-image-viewer style="z-index: 9999;" v-if="showImg" :on-close="closeImg" :url-list="imgList" />
	</div>
</template>

<script>
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';
	import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
	
	import {downloadStream} from "@/utils/downloadFileStream";
	
	export default {
	  //import引入的组件需要注入到对象中才能使用
	  components: {
		  ElImageViewer
	  },
	  data() {
	    //这里存放数据
	    return {
				uploadloading:false,
				queryParams: {
					page:1,
					limit:10,
					companyProductCodeList:[],
					productCode:'',
				},
				companyProductCode:'',// 批量检索
				productCode:'',//批量检索
				loading:false,
				dataList:[],
				total:0,
				flag: false,
				showImg:false,
				// 查看图片
				imgList:[],
				// 统计信息
				skuStatistics:{
					totalSku:0,
					totalPcs:0,
					totalVolume:0,
				}
			}
		},
		//方法集合
		methods: {
			// 分页条数
			handleSizeChange(size) {
			  this.queryParams.limit = size;
			  this.queryParams.page = 1;
			  this.getList();
			},
			// 分页页数
			handleCurrentChange(page) {
			  this.queryParams.page = page;
			  this.getList();
			},
			// 获取统计信息
			async getSkuStatistics(){
				const res = await this.$http.get("/toborder/wms/product/stat");
				if (res.code === 200) {
					this.skuStatistics.totalSku = res.data.skuCount;
					this.skuStatistics.totalPcs = res.data.productCount;
					this.skuStatistics.totalVolume = res.data.productVolume == null?0:res.data.productVolume;
					this.$nextTick(() => {
						this.$refs.skuStatisticsOne.start();
						this.$refs.skuStatisticsTwo.start();
					})
					
				} else {
				  this.$message.error(res.msg);
				}
			},
			// 导出SKU信息
			handleExportProduct(){
				this.uploadloading = true;
				const res = this.$http.post("/toborder/wms/product/exportInventory",{},{
					headers:{
						'Content-Type': 'application/json;charset=UTF-8',
					},
					responseType:'blob',
				}).then(res => {
				    if (res.code != 500) {
				      // window.open("http://awb.dlvd.com/vip_excel/download/" + res.msg);
							downloadStream(res,'xlsx','SKU库存信息')
				    }
						this.uploadloading = false;
				  }).catch(error => {
						this.uploadloading = false;
						this.$message.error(res.msg);
					});
			},
			// 搜索商品编号接口和查询列表接口返回数据一样，但是搜索商品编码接口参数为空，不返回数据，需要判断并调用查询列表接口
			async getList() {
				this.loading = true;
				this.dataList = [];
				const res = await this.$http.post("/toborder/wms/product/getInventoryInformation",this.queryParams);
				
				if (res.code === 200) {
				  this.loading = false;
				  this.dataList = res.data.list;
					this.total = res.data.totalCount;
					this.dataList.forEach(item => {
						if(item.productImages != null && item.productImages != ''){
							let img = JSON.parse(item.productImages);
							item.img = img;
						}else{
							item.img = '';
						}
						
						})
				} else {
				  this.loading = false;
				  this.$message.error(res.msg);
				}
			},
			
			handleQuery(){
				if(this.companyProductCode != ''){
					this.queryParams.companyProductCodeList = this.strToArr(this.companyProductCode);
				}else{
					this.queryParams.companyProductCodeList = [];
				}
				this.queryParams.page = 1;
				this.getList();
				this.getSkuStatistics();
			},
			handleReset(){
				this.queryParams = {
					page:1,
					limit:10,
					companyProductCodeList:[],
					productCode:'',
				}
				this.getList();
				this.getSkuStatistics();
			},
			// 查看图片
			handleViewImg(img){
				this.imgList = [];
				if(img.indexOf(',') == -1){
				  this.imgList.push(img[0])
				}else{
				  this.imgList = img.split(',');
				}
				this.showImg = true;
			},
			//关闭图片
			closeImg() {
				this.showImg = false;
			},
		},
		created() {
			this.getList();
			this.getSkuStatistics();
		}
	}
</script>

<style scoped>
	.listHeader{
		width: 100%;
		height: 50px;
		line-height: 50px;
		font-size: 22px;
	}
	.listHeader i{
		width: 4px;
		height: 40px;
		display: inline-block;
		background-color: #0077AA;
		float: left;
		margin: 5px 10px;
	}
	.listHeader span{
		display: inline-block;
		float: left;
	}
	.pageBottom {
	  padding: 20px 0 0 50px;
	}
</style>
<style scoped lang="scss">
	.skuStatistics{
		margin: 5px 15px;
	}
	.statOpt{
		display: inline-block;
		margin-right: 40px;
		font-size: 18px;
	}
	.statOpt label{
		margin-right: 10px;
	}
	.statOpt span{
		font-weight: bold;
		color: #409EFF;
	}
	// 阿拉伯语
	[lang="ar"] {
		.listHeader{
			i{
				float: right;
			}
			span{
				float: right;
			}
		}
		
		::v-deep .el-form-item__label{
			float: right;
		}
		.el-form-item__content{
			.el-button--primary{
				margin-left: 10px;
			}
		}
		// 表格
		::v-deep .el-table__fixed-right{
			left: 0;
			right: auto;
			.el-table__fixed-body-wrapper{
				left: 0;
				right: auto;
			}
		}
		::v-deep .el-table__fixed-right .el-table__fixed-header-wrapper{
			left: 0;
			right: auto;
		}
		::v-deep .fixed-width .el-button{
			margin: 0 5px 0 0 !important;
			i{
				margin-left: 5px;
			}
		}
		::v-deep .el-dropdown{
			margin: 0 5px 0 0 !important;
			.batchInfoItem{
				width: 20px;
				height: 20px;
				left: -15px;
				right: auto;
				top:-5px;
			}
			span{
				margin-left: -5px;
				float: right;
			}
			i{
				float: right;
				margin: 6px 0 0 5px;
			}
		}
		::v-deep .is-dot {
			left: -2px;
			right: auto;
			top: 6px;
		}
		::v-deep .el-dialog__headerbtn{
			right: auto;
			left: 20px;
		}
		::v-deep .el-dialog__footer {
			text-align: left;
			.el-button {
				margin: 0 10px;
			}
		}
		::v-deep .el-select .el-tag{
			margin: 0 5px;
		}
		::v-deep .el-select .el-tag__close.el-icon-close{
			right: 5px;
		}
		::v-deep .el-tabs__nav{
			float: right;
		}
	}
</style>